import React from 'react';
import { Link } from 'react-router-dom';

function CookieConsent() {
  const [visible, setVisible] = React.useState(false);

  React.useEffect(() => {
    const cookieChoice = localStorage.getItem('bromeli-cookie-consent');
    if (!cookieChoice) {
      setVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('bromeli-cookie-consent', 'accepted');
    setVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('bromeli-cookie-consent', 'declined');
    setVisible(false);
  };

  const handleCustomize = () => {
    localStorage.setItem('bromeli-cookie-consent', 'customized');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="cookie-consent">
      <h3>🍪 Süti kezelés</h3>
      <p>
        Weboldalunk sütiket (cookie) használ a felhasználói élmény javítása érdekében. 
        A sütik segítenek az analitikában, a tartalom személyre szabásában és a weboldal működésének fejlesztésében. 
        A teljes körű tájékoztatásért kérjük, tekintse meg az <Link to="/privacy-policy">Adatvédelmi irányelveket</Link>.
      </p>
      <div className="cookie-actions">
        <button className="cookie-btn cookie-btn-accept" onClick={handleAccept}>Összes elfogadása</button>
        <button className="cookie-btn cookie-btn-decline" onClick={handleDecline}>Elutasítás</button>
      </div>
    </div>
  );
}

export default CookieConsent;